import React, { useState } from 'react';
import ExpiryAlerts from './expiry-alerts';
import RecentPurchasesBlock from './recent-purchases-block';
import UnsettledAmount from './unsettled-amount';

const ExpityPurchasesWrapper: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [activeView, setActiveView] = useState<'purchases' | 'expiry' | 'unsettled'>('purchases');

  // Handle window resize for mobile detection
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      width: '100%',
      maxWidth: isMobile ? '100%' : '800px',
      marginLeft: 'auto',
      marginRight: 'auto',
      boxSizing: 'border-box'
    }}>
      {/* Toggle Switch */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: isMobile ? '1.5rem' : '2rem',
        gap: '1rem',
        padding: isMobile ? '0 0.5rem' : '0',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: isMobile ? '0.25rem' : '0.75rem',
          background: 'rgba(16, 185, 129, 0.1)',
          padding: isMobile ? '0.2rem' : '0.25rem',
          borderRadius: isMobile ? '8px' : '10px',
          border: '1px solid rgba(16, 185, 129, 0.2)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          width: isMobile ? '100%' : 'auto',
          maxWidth: isMobile ? '100%' : 'none',
          boxSizing: 'border-box',
          flexWrap: isMobile ? 'nowrap' : 'nowrap',
          overflow: isMobile ? 'hidden' : 'visible'
        }}>
          <button
            onClick={() => setActiveView('purchases')}
            style={{
              background: activeView === 'purchases'
                ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                : 'transparent',
              color: activeView === 'purchases' ? 'white' : '#6b7280',
              border: 'none',
              padding: isMobile ? '0.5rem 0.625rem' : '0.75rem 1.25rem',
              borderRadius: isMobile ? '6px' : '8px',
              fontSize: isMobile ? '0.75rem' : '0.9rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap',
              boxShadow: activeView === 'purchases' ? '0 2px 8px rgba(16, 185, 129, 0.3)' : 'none',
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? '0.375rem' : '0.5rem',
              flex: isMobile ? '1' : 'none',
              minWidth: isMobile ? '0' : 'auto',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
              if (activeView !== 'purchases') {
                e.currentTarget.style.color = '#10b981';
                e.currentTarget.style.background = 'rgba(16, 185, 129, 0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (activeView !== 'purchases') {
                e.currentTarget.style.color = '#6b7280';
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <svg width={isMobile ? "14" : "16"} height={isMobile ? "14" : "16"} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6"/>
            </svg>
            {isMobile ? 'Purchases' : 'Purchases'}
          </button>
          <button
            onClick={() => setActiveView('expiry')}
            style={{
              background: activeView === 'expiry'
                ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
                : 'transparent',
              color: activeView === 'expiry' ? 'white' : '#6b7280',
              border: 'none',
              padding: isMobile ? '0.5rem 0.625rem' : '0.75rem 1.25rem',
              borderRadius: isMobile ? '6px' : '8px',
              fontSize: isMobile ? '0.75rem' : '0.9rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap',
              boxShadow: activeView === 'expiry' ? '0 2px 8px rgba(239, 68, 68, 0.3)' : 'none',
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? '0.375rem' : '0.5rem',
              flex: isMobile ? '1' : 'none',
              minWidth: isMobile ? '0' : 'auto',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
              if (activeView !== 'expiry') {
                e.currentTarget.style.color = '#ef4444';
                e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (activeView !== 'expiry') {
                e.currentTarget.style.color = '#6b7280';
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <svg width={isMobile ? "14" : "16"} height={isMobile ? "14" : "16"} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
            {isMobile ? 'Expiry' : 'Expiry Alerts'}
          </button>
          <button
            onClick={() => setActiveView('unsettled')}
            style={{
              background: activeView === 'unsettled'
                ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                : 'transparent',
              color: activeView === 'unsettled' ? 'white' : '#6b7280',
              border: 'none',
              padding: isMobile ? '0.5rem 0.625rem' : '0.75rem 1.25rem',
              borderRadius: isMobile ? '6px' : '8px',
              fontSize: isMobile ? '0.75rem' : '0.9rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap',
              boxShadow: activeView === 'unsettled' ? '0 2px 8px rgba(245, 158, 11, 0.3)' : 'none',
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? '0.375rem' : '0.5rem',
              flex: isMobile ? '1' : 'none',
              minWidth: isMobile ? '0' : 'auto',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
              if (activeView !== 'unsettled') {
                e.currentTarget.style.color = '#f59e0b';
                e.currentTarget.style.background = 'rgba(245, 158, 11, 0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (activeView !== 'unsettled') {
                e.currentTarget.style.color = '#6b7280';
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <svg width={isMobile ? "14" : "16"} height={isMobile ? "14" : "16"} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
            {isMobile ? 'Unsettled' : 'Unsettled Amount'}
          </button>
        </div>
      </div>

      {/* Content Blocks - Below Toggle Switch */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)',
        backdropFilter: 'blur(25px)',
        borderRadius: isMobile ? '16px' : '20px',
        padding: isMobile ? '1.5rem' : '2rem',
        border: '1px solid rgba(16, 185, 129, 0.15)',
        boxShadow: '0 8px 24px rgba(16, 185, 129, 0.1)',
        marginBottom: isMobile ? '2rem' : '3rem',
        maxWidth: isMobile ? '100%' : '800px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }}>
        {/* Content - Conditional Rendering */}
        {activeView === 'expiry' ? (
          <ExpiryAlerts />
        ) : activeView === 'unsettled' ? (
          <UnsettledAmount />
        ) : (
          <RecentPurchasesBlock />
        )}
      </div>
    </div>
  );
};

export default ExpityPurchasesWrapper;

